import React from "react";

/**
 * SportsHero.jsx
 * - Pure React + CSS (no JS)
 * - Uses the uploaded image at /mnt/data/Screenshot 2025-11-16 150712.png
 */
const BG = "https://i.postimg.cc/t4YRDRbd/6390.jpg";

export default function HeroCard26() {
  return (
    <> 
    
      <header className="sh-hero">
        {/* Background image */}
        <div className="sh-bg" aria-hidden />

        {/* Left content */}
        <div className="sh-inner">
          <div className="sh-left">
            <h2 className="sh-kicker">PLAY LIKE A <span className="sh-cta sh-Name">CHAMPION</span> TODAY</h2>

            <p className="sh-lead">
              Te obtinuit ut adepto satis somno. Aliisque institoribus iter deliciae
              vivet vita. Nam exempli gratia.
            </p>

            <a className="sh-cta" href="#readmore">READ MORE</a>
          </div>

          {/* Right decorative arrows (static) */}
          <div className="sh-arrows">
            <div className="sh-arrow sh-left-arrow" aria-hidden>◀</div>
            <div className="sh-arrow sh-right-arrow" aria-hidden>▶</div>
          </div>
        </div>

        {/* bottom diagonal footer strip */}
        <div className="sh-footer-strip">
          <div className="sh-footer-inner">
            <div className="sh-logo">SPORTS</div>
            <nav className="sh-nav">
              <a>HOME</a>
              <a> PAGES </a>
              <a> BLOG </a>
              <a> CONTACT </a>
            </nav>
            <div className="sh-buy">BUY NOW</div>
          </div>
        </div>
      </header>

      <style>{`
/* ---------- HERO WRAPPER ---------- */
.sh-Name{top:25px; color:#ffffff !important}
.sh-hero {
  position: relative;
  min-height: 78vh;
  overflow: hidden;
  color: #fff;
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
}

/* background image (using uploaded path) */
.sh-bg {
  position: absolute;
  inset: 0;
  background-image: url('${BG}');
  background-size: cover;
  background-position: center right;
  filter: saturate(0.9) contrast(0.95);
  transform: translateZ(0);
  z-index: 0;
}

/* dark gradient overlay to ensure text contrast */
.sh-hero::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(6,6,6,0.55) 0%, rgba(6,6,6,0.18) 55%, rgba(6,6,6,0.6) 100%);
  z-index: 1;
}

/* inner content container */
.sh-inner {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 72px 8%;
  min-height: 78vh;
}

/* left column */
.sh-left {
  max-width: 720px;
}

/* kicker / headline */
.sh-kicker {
  font-family: "Playfair Display", Georgia, "Times New Roman", serif;
  font-size: 3rem;
  font-weight: 700;
  letter-spacing: 1px;
  margin: 0 0 18px;
  line-height: 1.05;
  color: rgba(255,255,255,0.95);
  text-transform: uppercase;
}
.sh-kicker span {
  color: #ff7a2b; /* champion orange */
}

/* lead paragraph */
.sh-lead {
  max-width: 60ch;
  color: rgba(255,255,255,0.9);
  opacity: 0.95;
  margin-bottom: 28px;
  font-size: 1.05rem;
  line-height: 1.6;
}

/* CTA button styled like screenshot */
.sh-cta {
  display: inline-block;
  padding: 14px 34px;
  background: linear-gradient(135deg,#ff7a2b,#ff944a);
  color: white;
  text-decoration: none;
  font-weight: 700;
  border-radius: 2px;
  position: relative;
  box-shadow: 10px 10px 0 rgba(255,255,255,0.1); 
  transform: translateY(-20px) skewX(-20deg) translateZ(-20px);;;
  transition: transform 220ms ease, box-shadow 220ms ease;
}

.sh-cta:hover {
  transform: translateY(-20px)  translateX(20px) skewX(-20deg) translateZ(-20px);;;
  box-shadow: 14px 14px 0 rgba(255,255,255,0.08);
}

/* decorative arrows on edges (static) */
.sh-arrows {
  position: absolute;
  right: 32px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  display:flex;
  flex-direction:column;
  gap: 24px;
}
.sh-arrow {
  width: 44px;
  height: 44px;
  display:grid;
  place-items:center;
  border-radius:6px;
  background: rgba(255,255,255,0.06);
  color: #fff;
  border: 2px solid rgba(255,255,255,0.06);
  font-weight:700;
}
.sh-right-arrow {
  background: #ff7a2b;
  color: white;
}

/* ---------- Bottom diagonal footer strip ---------- */
.sh-footer-strip {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  background: #0b0b0b;
  padding: 0;
  transform: translateY(0);
}

/* create the diagonal white shape and orange menu area */
.sh-footer-inner {
  max-width: 1400px;
  margin: 0 auto;
  display:flex;
  align-items:center;
  gap: 22px;
  padding: 28px 0;
  position: relative;
}

/* white angled block on left */
.sh-logo {
  background: white;
  color: #111;
  font-weight: 800;
  padding: 18px 36px;
  margin-right: -40px;
  transform: skewX(-12deg);
  box-shadow: 0 8px 20px rgba(0,0,0,0.12);
}

/* simple nav center */
.sh-nav {
  display:flex;
  gap: 28px;
  color: #fff;
  letter-spacing: 2px;
  margin-left: 40px;
}
.sh-nav a {
  color: #fff;
  opacity: 0.95;
}

/* buy button on right */
.sh-buy {
  margin-left: auto;
  background: #0b3b74;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  font-weight: 700;
  margin-right: 36px;
}

/* ---------- small responsiveness ---------- */
@media (max-width: 980px) {
  .sh-inner { padding: 48px 6%; }
  .sh-kicker { font-size: 2.1rem; }
  .sh-left { max-width: 100%; }
  .sh-arrows { display:none; }
  .sh-footer-inner { flex-direction: column; gap: 12px; padding: 18px 12px; }
  .sh-nav { justify-content:center; margin-left: 0; }
  .sh-logo { margin-right: 0; transform: none; padding: 12px 20px; }
}

/* small screens */
@media (max-width: 560px) {
  .sh-kicker { font-size: 1.6rem; line-height:1.15; }
  .sh-cta { padding: 10px 18px; }
}
      `}</style>
    </>
  );
}
